import { makeImageUrls } from "@ezbuy/smartimagesrc";
const defaultImage = "https://d3hp955ol7sp5f.cloudfront.net/newhome/placeholder/ezbuy_456x456.png";
export function* imageSourceGenerator(originSrc, params, fallbackSrc = defaultImage) {
    const urls = makeImageUrls(originSrc, params);
    if (fallbackSrc) {
        urls.push(fallbackSrc);
    }
    for (let i = 0, l = urls.length; i < l; i++) {
        yield urls[i];
    }
    return originSrc;
}
